// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ===== example.js 디자인 시스템 ===== */
:root {
  --color-bg-outer: #fff;
  --color-bg-main: var(--brand-page-background);
  --color-bg-card: #ffffff;
  --color-border: #e5e8eb;
  --color-border-dark: #d1d6db;
  --color-text-primary: #191f28;
  --color-text-secondary: #4e5968;
  --color-text-muted: #8b95a1;
  --color-text-disabled: #adb5bd;
  --color-primary: var(--brand-primary);
  --color-primary-dark: var(--brand-primary-hover);
  --color-primary-hover: var(--brand-primary-active);
  --color-success: #04c084;
  --color-error: #f04452;
}

body {
  margin: 0;
  background-color: var(--color-bg-outer);
}

/* 앱 모바일 화면: html, body 높이 제한 */
html.app-mobile-body,
body.app-mobile-body {
  height: 100dvh;
  min-height: 100dvh;
  max-height: 100dvh;
  overflow: hidden;
  overflow-x: hidden;
  overflow-y: hidden;
  position: fixed;
  width: 100%;
  max-width: 100vw;
}

/* 수기결제 팝업(/cp/sugi): 1920px 고정 해제, 내부 스크롤 영역만 스크롤 */
html.sugi-popup-body,
body.sugi-popup-body {
  overflow: hidden !important;
  overflow-x: hidden !important;
  height: 100vh;
  min-height: 100vh;
  position: fixed;
  width: 100%;
  max-width: 100vw;
}

/* 수기결제 팝업: #root 높이 체인 (스크롤 동작을 위해) */
body.sugi-popup-body #root {
  height: 100%;
  min-height: 0;
  display: flex;
  flex-direction: column;
}

.sugi-popup {
  width: 100%;
  min-width: 0;
  max-width: 100vw;
  height: 100vh;
  min-height: 0;
  flex: 1 1;
  overflow: hidden;
  overflow-x: hidden;
  justify-content: flex-start;
  display: flex;
  flex-direction: column;
}

.sugi-popup .App {
  width: 100%;
  min-width: 0;
  max-width: 100%;
  flex: 1 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  overflow-x: hidden;
}

/* 뷰포트 920px 이상: 높이 100vh 고정, 세로 스크롤 없음. 가로는 항상 스크롤 가능 */
.app-wrapper {
  width: 100%;
  min-height: 100vh;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  background-color: var(--color-bg-outer);
  overflow-x: auto;
}

@media (min-height: 920px) {
  .app-wrapper {
    height: 100vh;
    overflow-y: hidden;
  }
}

@media (max-height: 919px) {
  .app-wrapper {
    overflow-y: auto;
  }
}

/* 1920px 이상일 때만 가운데 정렬 */
@media (min-width: 1920px) {
  .app-wrapper {
    justify-content: center;
  }
}

/* 관리자 정산(Settlement_1) 전용: 1700px~1920px 반응형 */
.app-wrapper.admin-settlement-responsive .App {
  width: 100%;
  min-width: 1700px;
  max-width: 1920px;
}
@media (min-width: 1700px) {
  .app-wrapper.admin-settlement-responsive {
    justify-content: center;
  }
}

/* 고정 너비 1920px, 높이는 100vh(920 이상에선 스크롤 없음) */
.App {
  width: 1920px;
  min-width: 1920px;
  min-height: 100vh;
  position: relative;
  background-color: var(--color-bg-main);
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
  font-family: 'Pretendard', sans-serif;
  color: #191f28;
}

/* 앱(/app) 화면만 모바일 형태: 최대 768px, 가운데 정렬 */
.app-wrapper.app-mobile {
  width: 100%;
  max-width: 768px;
  margin: 0 auto;
  background-color: transparent;
  height: 100dvh;
  min-height: 100dvh;
  max-height: 100dvh;
  overflow: hidden;
  overflow-x: hidden;
  overflow-y: hidden;
  justify-content: center;
}

.app-wrapper.app-mobile .App {
  width: 100%;
  min-width: 0;
  max-width: 100%;
  height: 100%;
  min-height: 100%;
  max-height: 100%;
  overflow: hidden;
  overflow-x: hidden;
  overflow-y: hidden;
  box-shadow: none;
}

a {
  text-decoration: none;
}

/* 토스페이먼츠 스타일 스크롤바 */
.custom-scrollbar::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

.custom-scrollbar::-webkit-scrollbar-track {
  background: transparent;
}

.custom-scrollbar::-webkit-scrollbar-thumb {
  background: #d1d6db;
  border-radius: 4px;
}

.custom-scrollbar::-webkit-scrollbar-thumb:hover {
  background: #adb5bd;
}

/* ===== 정산달력 (react-calendar) - 구글 캘린더 느낌 ===== */
.react-calendar-custom {
  width: 100%;
  border: none;
  font-family: inherit;
}

.react-calendar-custom .react-calendar__navigation {
  display: none;
  /* display: flex !important;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: fit-content;
  margin: 0 auto 8px; */
}

.react-calendar-custom .react-calendar__navigation button {
  min-width: auto;
  background: transparent;
  border: none;
  padding: 6px 10px;
  border-radius: 4px;
  font-size: 18px;
  font-weight: 600;
  color: #191f28;
}

/* 월 변경 화살표(<, >)만 더 크게 */
.react-calendar-custom .react-calendar__navigation__prev-button,
.react-calendar-custom .react-calendar__navigation__next-button {
  font-size: 22px;
  padding: 8px 12px;
}

.react-calendar-custom .react-calendar__navigation button:enabled:hover {
  background-color: #f2f4f6;
}

/* 맨 앞/뒤로 이동 화살표는 숨김 (구글캘린더처럼 이전/다음만 사용) */
.react-calendar-custom .react-calendar__navigation__prev2-button,
.react-calendar-custom .react-calendar__navigation__next2-button {
  display: none;
}

.react-calendar-custom .react-calendar__navigation__label {
  flex: none;
  text-align: center;
  font-size: 24px;
  font-weight: 700;
  width: 120px;
}

.react-calendar-custom .react-calendar__month-view__weekdays {
  text-transform: none;
  font-size: 12px;
  color: #8b95a1;
}

.react-calendar-custom .react-calendar__month-view__days {
  border-top: 1px solid #e5e8eb;
  border-left: 1px solid #e5e8eb;
}

.react-calendar-custom .react-calendar__month-view__weekdays__weekday {
  padding: 4px 0;
}

.react-calendar-custom .react-calendar__tile {
  height: 100px;
  padding: 4px;
  border-radius: 4px;
  position: relative;
  font-size: 16px;
  /* 날짜 숫자 크게 */
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  border-right: 1px solid #e5e8eb;
  border-bottom: 1px solid #e5e8eb;
}

.react-calendar-custom .react-calendar__tile abbr {
  text-decoration: none;
}

.react-calendar-custom .react-calendar__tile:enabled:hover {
  background-color: #f2f4f6;
}

/* 오늘 날짜: 상·좌만 투명, 하·우는 그리드선 유지 (border-bottom 없음 현상 방지) */
.react-calendar-custom .react-calendar__tile--now {
  background: transparent;
  border: 1px solid transparent;
  border-right: 1px solid #e5e8eb;
  border-bottom: 1px solid #e5e8eb;
  box-sizing: border-box;
}

.react-calendar-custom .react-calendar__tile--active {
  background: #ffffff !important;
  border: 2px solid var(--brand-primary);
  box-sizing: border-box;
  color: #191f28;
  /* 선택된 일자: 칸 자체를 1.2배 확대, 주변을 살짝 가리며 앞으로 튀어나오는 효과 */
  transform: scale(1.02);
  z-index: 5;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.react-calendar-custom .react-calendar__tile--active abbr {
  color: #191f28;
  font-weight: 600;
}

.react-calendar-custom .has-settlement {
  background-color: #f8fbff;
}

.react-calendar-custom .has-settlement .react-calendar__tile:enabled:hover {
  background-color: var(--brand-primary-soft);
}

.react-calendar-custom .react-calendar__month-view__weekdays__weekday {
  padding: 4px 0;
  text-align: center;
}

/* 전달/다음달에 포함된 날짜 스타일 */
.react-calendar-custom .react-calendar__month-view__days__day--neighboringMonth {
  color: #c0c4cc;
  background-color: #f8f9fb;
}

/* 통합정산 달력: 기본은 컴팩트, 선택된 날짜만 기존처럼 크게 */
.integrated-settlement-calendar .react-calendar__tile {
  height: 105px;
}

/* ===== 입금완료 월 선택 (react-datepicker showMonthYearPicker) ===== */
.deposit-month-picker {
  border: none !important;
  font-family: inherit;
}
.deposit-month-picker .react-datepicker__month-container {
  float: none;
}
.deposit-month-picker .react-datepicker__month-wrapper {
  display: grid !important;
  grid-template-columns: repeat(4, 1fr);
  gap: 4px;
}
.deposit-month-picker .react-datepicker__month-text {
  padding: 10px 8px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
}
.deposit-month-picker .react-datepicker__month-text:hover {
  background-color: var(--brand-primary-soft);
  color: var(--brand-primary);
}
.deposit-month-picker .react-datepicker__month-text--keyboard-selected {
  background-color: var(--brand-primary) !important;
  color: white !important;
}
.deposit-month-picker .react-datepicker__month-text--selected {
  background-color: var(--brand-primary) !important;
  color: white !important;
}
.deposit-month-picker .react-datepicker__header {
  background: #f9fafb;
  border-bottom: 1px solid #e5e7eb;
  padding-top: 12px;
}
.deposit-month-picker .react-datepicker__current-month {
  font-size: 16px;
  font-weight: 700;
  color: #191f28;
  margin-bottom: 12px;
}
.deposit-month-picker .react-datepicker__navigation {
  top: 12px;
}
.deposit-month-picker .react-datepicker__navigation-icon::before {
  border-color: #6b7280;
}


.styles-module_tooltip__mnnfp {
  width: auto !important;
  /* max-width: 300px !important; */
  padding: 6px 8px !important;
  font-size: 11px !important;
  white-space: pre-line !important;
}

@keyframes gasystem-customer-sheet-backdrop-in {
  from { opacity: 0; }
  to { opacity: 1; }
}

@keyframes gasystem-customer-sheet-up {
  from { transform: translateY(100%); }
  to { transform: translateY(0); }
}

.gasystem-customer-sheet-backdrop {
  animation: gasystem-customer-sheet-backdrop-in 160ms ease-out both;
}

.gasystem-customer-sheet {
  animation: gasystem-customer-sheet-up 220ms cubic-bezier(0.22, 1, 0.36, 1) both;
}

@media (prefers-reduced-motion: reduce) {
  .gasystem-customer-sheet-backdrop,
  .gasystem-customer-sheet {
    animation: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA,mCAAmC;AACnC;EACE,sBAAsB;EACtB,6CAA6C;EAC7C,wBAAwB;EACxB,uBAAuB;EACvB,4BAA4B;EAC5B,6BAA6B;EAC7B,+BAA+B;EAC/B,2BAA2B;EAC3B,8BAA8B;EAC9B,qCAAqC;EACrC,gDAAgD;EAChD,kDAAkD;EAClD,wBAAwB;EACxB,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,uCAAuC;AACzC;;AAEA,+BAA+B;AAC/B;;EAEE,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA,oDAAoD;AACpD;;EAEE,2BAA2B;EAC3B,6BAA6B;EAC7B,aAAa;EACb,iBAAiB;EACjB,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA,sCAAsC;AACtC;EACE,YAAY;EACZ,aAAa;EACb,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,aAAa;EACb,SAAO;EACP,gBAAgB;EAChB,kBAAkB;EAClB,2BAA2B;EAC3B,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,SAAO;EACP,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,wDAAwD;AACxD;EACE,WAAW;EACX,iBAAiB;EACjB,aAAa;EACb,2BAA2B;EAC3B,uBAAuB;EACvB,uCAAuC;EACvC,gBAAgB;AAClB;;AAEA;EACE;IACE,aAAa;IACb,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA,yBAAyB;AACzB;EACE;IACE,uBAAuB;EACzB;AACF;;AAEA,+CAA+C;AAC/C;EACE,WAAW;EACX,iBAAiB;EACjB,iBAAiB;AACnB;AACA;EACE;IACE,uBAAuB;EACzB;AACF;;AAEA,6CAA6C;AAC7C;EACE,aAAa;EACb,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,sCAAsC;EACtC,iDAAiD;EACjD,qCAAqC;EACrC,cAAc;AAChB;;AAEA,yCAAyC;AACzC;EACE,WAAW;EACX,gBAAgB;EAChB,cAAc;EACd,6BAA6B;EAC7B,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;;AAEA,oBAAoB;AACpB;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,kDAAkD;AAClD;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb;;;;;uBAKqB;AACvB;;AAEA;EACE,eAAe;EACf,uBAAuB;EACvB,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA,yBAAyB;AACzB;;EAEE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,0CAA0C;AAC1C;;EAEE,aAAa;AACf;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,6BAA6B;EAC7B,8BAA8B;AAChC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,2BAA2B;EAC3B,+BAA+B;EAC/B,gCAAgC;AAClC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,0DAA0D;AAC1D;EACE,uBAAuB;EACvB,6BAA6B;EAC7B,+BAA+B;EAC/B,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA;EACE,8BAA8B;EAC9B,sCAAsC;EACtC,sBAAsB;EACtB,cAAc;EACd,mDAAmD;EACnD,sBAAsB;EACtB,UAAU;EACV,0CAA0C;AAC5C;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA,uBAAuB;AACvB;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA,sCAAsC;AACtC;EACE,aAAa;AACf;;AAEA,iEAAiE;AACjE;EACE,uBAAuB;EACvB,oBAAoB;AACtB;AACA;EACE,WAAW;AACb;AACA;EACE,wBAAwB;EACxB,qCAAqC;EACrC,QAAQ;AACV;AACA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,2CAA2C;EAC3C,2BAA2B;AAC7B;AACA;EACE,iDAAiD;EACjD,uBAAuB;AACzB;AACA;EACE,iDAAiD;EACjD,uBAAuB;AACzB;AACA;EACE,mBAAmB;EACnB,gCAAgC;EAChC,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,SAAS;AACX;AACA;EACE,qBAAqB;AACvB;;;AAGA;EACE,sBAAsB;EACtB,iCAAiC;EACjC,2BAA2B;EAC3B,0BAA0B;EAC1B,gCAAgC;AAClC;;AAEA;EACE,OAAO,UAAU,EAAE;EACnB,KAAK,UAAU,EAAE;AACnB;;AAEA;EACE,OAAO,2BAA2B,EAAE;EACpC,KAAK,wBAAwB,EAAE;AACjC;;AAEA;EACE,kEAAkE;AACpE;;AAEA;EACE,+EAA+E;AACjF;;AAEA;EACE;;IAEE,eAAe;EACjB;AACF","sourcesContent":["/* ===== example.js 디자인 시스템 ===== */\n:root {\n  --color-bg-outer: #fff;\n  --color-bg-main: var(--brand-page-background);\n  --color-bg-card: #ffffff;\n  --color-border: #e5e8eb;\n  --color-border-dark: #d1d6db;\n  --color-text-primary: #191f28;\n  --color-text-secondary: #4e5968;\n  --color-text-muted: #8b95a1;\n  --color-text-disabled: #adb5bd;\n  --color-primary: var(--brand-primary);\n  --color-primary-dark: var(--brand-primary-hover);\n  --color-primary-hover: var(--brand-primary-active);\n  --color-success: #04c084;\n  --color-error: #f04452;\n}\n\nbody {\n  margin: 0;\n  background-color: var(--color-bg-outer);\n}\n\n/* 앱 모바일 화면: html, body 높이 제한 */\nhtml.app-mobile-body,\nbody.app-mobile-body {\n  height: 100dvh;\n  min-height: 100dvh;\n  max-height: 100dvh;\n  overflow: hidden;\n  overflow-x: hidden;\n  overflow-y: hidden;\n  position: fixed;\n  width: 100%;\n  max-width: 100vw;\n}\n\n/* 수기결제 팝업(/cp/sugi): 1920px 고정 해제, 내부 스크롤 영역만 스크롤 */\nhtml.sugi-popup-body,\nbody.sugi-popup-body {\n  overflow: hidden !important;\n  overflow-x: hidden !important;\n  height: 100vh;\n  min-height: 100vh;\n  position: fixed;\n  width: 100%;\n  max-width: 100vw;\n}\n\n/* 수기결제 팝업: #root 높이 체인 (스크롤 동작을 위해) */\nbody.sugi-popup-body #root {\n  height: 100%;\n  min-height: 0;\n  display: flex;\n  flex-direction: column;\n}\n\n.sugi-popup {\n  width: 100%;\n  min-width: 0;\n  max-width: 100vw;\n  height: 100vh;\n  min-height: 0;\n  flex: 1;\n  overflow: hidden;\n  overflow-x: hidden;\n  justify-content: flex-start;\n  display: flex;\n  flex-direction: column;\n}\n\n.sugi-popup .App {\n  width: 100%;\n  min-width: 0;\n  max-width: 100%;\n  flex: 1;\n  min-height: 0;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  overflow-x: hidden;\n}\n\n/* 뷰포트 920px 이상: 높이 100vh 고정, 세로 스크롤 없음. 가로는 항상 스크롤 가능 */\n.app-wrapper {\n  width: 100%;\n  min-height: 100vh;\n  display: flex;\n  justify-content: flex-start;\n  align-items: flex-start;\n  background-color: var(--color-bg-outer);\n  overflow-x: auto;\n}\n\n@media (min-height: 920px) {\n  .app-wrapper {\n    height: 100vh;\n    overflow-y: hidden;\n  }\n}\n\n@media (max-height: 919px) {\n  .app-wrapper {\n    overflow-y: auto;\n  }\n}\n\n/* 1920px 이상일 때만 가운데 정렬 */\n@media (min-width: 1920px) {\n  .app-wrapper {\n    justify-content: center;\n  }\n}\n\n/* 관리자 정산(Settlement_1) 전용: 1700px~1920px 반응형 */\n.app-wrapper.admin-settlement-responsive .App {\n  width: 100%;\n  min-width: 1700px;\n  max-width: 1920px;\n}\n@media (min-width: 1700px) {\n  .app-wrapper.admin-settlement-responsive {\n    justify-content: center;\n  }\n}\n\n/* 고정 너비 1920px, 높이는 100vh(920 이상에선 스크롤 없음) */\n.App {\n  width: 1920px;\n  min-width: 1920px;\n  min-height: 100vh;\n  position: relative;\n  background-color: var(--color-bg-main);\n  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);\n  font-family: 'Pretendard', sans-serif;\n  color: #191f28;\n}\n\n/* 앱(/app) 화면만 모바일 형태: 최대 768px, 가운데 정렬 */\n.app-wrapper.app-mobile {\n  width: 100%;\n  max-width: 768px;\n  margin: 0 auto;\n  background-color: transparent;\n  height: 100dvh;\n  min-height: 100dvh;\n  max-height: 100dvh;\n  overflow: hidden;\n  overflow-x: hidden;\n  overflow-y: hidden;\n  justify-content: center;\n}\n\n.app-wrapper.app-mobile .App {\n  width: 100%;\n  min-width: 0;\n  max-width: 100%;\n  height: 100%;\n  min-height: 100%;\n  max-height: 100%;\n  overflow: hidden;\n  overflow-x: hidden;\n  overflow-y: hidden;\n  box-shadow: none;\n}\n\na {\n  text-decoration: none;\n}\n\n/* 토스페이먼츠 스타일 스크롤바 */\n.custom-scrollbar::-webkit-scrollbar {\n  width: 6px;\n  height: 6px;\n}\n\n.custom-scrollbar::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n.custom-scrollbar::-webkit-scrollbar-thumb {\n  background: #d1d6db;\n  border-radius: 4px;\n}\n\n.custom-scrollbar::-webkit-scrollbar-thumb:hover {\n  background: #adb5bd;\n}\n\n/* ===== 정산달력 (react-calendar) - 구글 캘린더 느낌 ===== */\n.react-calendar-custom {\n  width: 100%;\n  border: none;\n  font-family: inherit;\n}\n\n.react-calendar-custom .react-calendar__navigation {\n  display: none;\n  /* display: flex !important;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  width: fit-content;\n  margin: 0 auto 8px; */\n}\n\n.react-calendar-custom .react-calendar__navigation button {\n  min-width: auto;\n  background: transparent;\n  border: none;\n  padding: 6px 10px;\n  border-radius: 4px;\n  font-size: 18px;\n  font-weight: 600;\n  color: #191f28;\n}\n\n/* 월 변경 화살표(<, >)만 더 크게 */\n.react-calendar-custom .react-calendar__navigation__prev-button,\n.react-calendar-custom .react-calendar__navigation__next-button {\n  font-size: 22px;\n  padding: 8px 12px;\n}\n\n.react-calendar-custom .react-calendar__navigation button:enabled:hover {\n  background-color: #f2f4f6;\n}\n\n/* 맨 앞/뒤로 이동 화살표는 숨김 (구글캘린더처럼 이전/다음만 사용) */\n.react-calendar-custom .react-calendar__navigation__prev2-button,\n.react-calendar-custom .react-calendar__navigation__next2-button {\n  display: none;\n}\n\n.react-calendar-custom .react-calendar__navigation__label {\n  flex: none;\n  text-align: center;\n  font-size: 24px;\n  font-weight: 700;\n  width: 120px;\n}\n\n.react-calendar-custom .react-calendar__month-view__weekdays {\n  text-transform: none;\n  font-size: 12px;\n  color: #8b95a1;\n}\n\n.react-calendar-custom .react-calendar__month-view__days {\n  border-top: 1px solid #e5e8eb;\n  border-left: 1px solid #e5e8eb;\n}\n\n.react-calendar-custom .react-calendar__month-view__weekdays__weekday {\n  padding: 4px 0;\n}\n\n.react-calendar-custom .react-calendar__tile {\n  height: 100px;\n  padding: 4px;\n  border-radius: 4px;\n  position: relative;\n  font-size: 16px;\n  /* 날짜 숫자 크게 */\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: flex-start;\n  border-right: 1px solid #e5e8eb;\n  border-bottom: 1px solid #e5e8eb;\n}\n\n.react-calendar-custom .react-calendar__tile abbr {\n  text-decoration: none;\n}\n\n.react-calendar-custom .react-calendar__tile:enabled:hover {\n  background-color: #f2f4f6;\n}\n\n/* 오늘 날짜: 상·좌만 투명, 하·우는 그리드선 유지 (border-bottom 없음 현상 방지) */\n.react-calendar-custom .react-calendar__tile--now {\n  background: transparent;\n  border: 1px solid transparent;\n  border-right: 1px solid #e5e8eb;\n  border-bottom: 1px solid #e5e8eb;\n  box-sizing: border-box;\n}\n\n.react-calendar-custom .react-calendar__tile--active {\n  background: #ffffff !important;\n  border: 2px solid var(--brand-primary);\n  box-sizing: border-box;\n  color: #191f28;\n  /* 선택된 일자: 칸 자체를 1.2배 확대, 주변을 살짝 가리며 앞으로 튀어나오는 효과 */\n  transform: scale(1.02);\n  z-index: 5;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n}\n\n.react-calendar-custom .react-calendar__tile--active abbr {\n  color: #191f28;\n  font-weight: 600;\n}\n\n.react-calendar-custom .has-settlement {\n  background-color: #f8fbff;\n}\n\n.react-calendar-custom .has-settlement .react-calendar__tile:enabled:hover {\n  background-color: var(--brand-primary-soft);\n}\n\n.react-calendar-custom .react-calendar__month-view__weekdays__weekday {\n  padding: 4px 0;\n  text-align: center;\n}\n\n/* 전달/다음달에 포함된 날짜 스타일 */\n.react-calendar-custom .react-calendar__month-view__days__day--neighboringMonth {\n  color: #c0c4cc;\n  background-color: #f8f9fb;\n}\n\n/* 통합정산 달력: 기본은 컴팩트, 선택된 날짜만 기존처럼 크게 */\n.integrated-settlement-calendar .react-calendar__tile {\n  height: 105px;\n}\n\n/* ===== 입금완료 월 선택 (react-datepicker showMonthYearPicker) ===== */\n.deposit-month-picker {\n  border: none !important;\n  font-family: inherit;\n}\n.deposit-month-picker .react-datepicker__month-container {\n  float: none;\n}\n.deposit-month-picker .react-datepicker__month-wrapper {\n  display: grid !important;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 4px;\n}\n.deposit-month-picker .react-datepicker__month-text {\n  padding: 10px 8px;\n  border-radius: 8px;\n  font-size: 14px;\n  font-weight: 500;\n}\n.deposit-month-picker .react-datepicker__month-text:hover {\n  background-color: var(--brand-primary-soft);\n  color: var(--brand-primary);\n}\n.deposit-month-picker .react-datepicker__month-text--keyboard-selected {\n  background-color: var(--brand-primary) !important;\n  color: white !important;\n}\n.deposit-month-picker .react-datepicker__month-text--selected {\n  background-color: var(--brand-primary) !important;\n  color: white !important;\n}\n.deposit-month-picker .react-datepicker__header {\n  background: #f9fafb;\n  border-bottom: 1px solid #e5e7eb;\n  padding-top: 12px;\n}\n.deposit-month-picker .react-datepicker__current-month {\n  font-size: 16px;\n  font-weight: 700;\n  color: #191f28;\n  margin-bottom: 12px;\n}\n.deposit-month-picker .react-datepicker__navigation {\n  top: 12px;\n}\n.deposit-month-picker .react-datepicker__navigation-icon::before {\n  border-color: #6b7280;\n}\n\n\n.styles-module_tooltip__mnnfp {\n  width: auto !important;\n  /* max-width: 300px !important; */\n  padding: 6px 8px !important;\n  font-size: 11px !important;\n  white-space: pre-line !important;\n}\n\n@keyframes gasystem-customer-sheet-backdrop-in {\n  from { opacity: 0; }\n  to { opacity: 1; }\n}\n\n@keyframes gasystem-customer-sheet-up {\n  from { transform: translateY(100%); }\n  to { transform: translateY(0); }\n}\n\n.gasystem-customer-sheet-backdrop {\n  animation: gasystem-customer-sheet-backdrop-in 160ms ease-out both;\n}\n\n.gasystem-customer-sheet {\n  animation: gasystem-customer-sheet-up 220ms cubic-bezier(0.22, 1, 0.36, 1) both;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .gasystem-customer-sheet-backdrop,\n  .gasystem-customer-sheet {\n    animation: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
